import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class McaApi {
  private prospektrBackendBaseURL = environment.prospektrBackendBaseURL;
  private findCountyApi = 'findCounty';
  constructor(private http: HttpClient) {}

  getCounty(params): Observable<any> {
    return new Observable((observer) => {
      this.http.post(`${this.prospektrBackendBaseURL}${this.findCountyApi}`, params).subscribe(
        (res) => {
          observer.next(res);
        },
        (err) => {
          observer.error(err.error);
        }
      );
    });
  }
}
